import TableBody from 'components/TableBody';
import TableFooter from 'components/TableFooter';
import { useGetFilterQuery, useGetMatchListQuery } from 'hooks/queries/match';

const MatchTable = () => {
	const {
		data: filter_data = null,
		isLoading: filter_loading,
		isFetching: filter_fetching,
	} = useGetFilterQuery();
	const {
		data: match_data = null,
		isLoading: match_loading,
		isFetching: match_fetching,
	} = useGetMatchListQuery();

	const loading =
		filter_loading ||
		match_loading ||
		filter_data === null ||
		match_data === null ||
		filter_fetching ||
		match_fetching;

	return (
		<>
			<TableBody loading={loading} data={match_data?.results} />
			{!loading && <TableFooter />}
		</>
	);
};

export default MatchTable;
